import 'css-chunksrc/client/scenes/projectElementDetailsConfiguration/form/columns/form/styles.scss';export default {
  "input": "_input_1e0ys_1",
  "listRoot": "_listRoot_1e0ys_14",
  "list": "_list_1e0ys_14",
  "item": "_item_1e0ys_30",
  "icon": "_icon_1e0ys_43",
  "name": "_name_1e0ys_51"
};